// import { BootstrapVue } from 'bootstrap-vue'
import { BContainer, BRow, BCol, CollapsePlugin} from 'bootstrap-vue'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './js/i18n'

import './scss/style.scss'

Vue.component('BContainer', BContainer)
Vue.component('BRow', BRow)
Vue.component('BCol', BCol)
// Vue.component('BCollapse', BCollapse)
Vue.use(CollapsePlugin);
// Vue.use(BootstrapVue);

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')

